module.exports = __webpack_public_path__ + "img/geneaologia.791ed37b.jpg";